import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IAction } from 'vnetwork-ui/dist/components/GokuDataGrid/Actions'

import GokuDataGrid from '@/components/GokuDataGrid'
import { generatePathDatacentral, paths } from '@/utils/path'
import { getResellersList } from '@/modules/Reseller/services'
import { Reseller } from '@/modules/Reseller/types'
import { resellerListColumns } from './columns'
import ActiveFilters from './Filters'

import EyeIcons from '@/icons/EyeIcons'

// Define outside component to prevent re-render
const FILTER_DEFAULT_VALUES = { status: '', tier: '' }

const Active = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('reseller')

    const actions: IAction<Reseller>[] = [
        {
            onClick: (row) =>
                navigate(
                    generatePathDatacentral(paths.resellerDetail, {
                        id: String(row?.reseller_id),
                    })
                ),
            title: t('view'),
            color: 'primary',
            icon: <EyeIcons />,
        },
    ]

    return (
        <div className="my-2">
            <GokuDataGrid
                apiCall={getResellersList}
                columns={resellerListColumns(t)}
                reactQueryKey="reseller-active"
                actions={actions}
                dataGridProps={{
                    getRowId: (row) => row?.reseller_id,
                }}
                searchPlaceholder={t('search_reseller')}
                filterDefaultValues={FILTER_DEFAULT_VALUES}
            >
                {({ control, watch, setValue }) => (
                    <ActiveFilters
                        control={control}
                        watch={watch}
                        setValue={(name, value) => setValue(name as any, value)}
                    />
                )}
            </GokuDataGrid>
        </div>
    )
}

export default Active
